module.exports = __webpack_public_path__ + "img/stack05.2fe031fa.svg";